import { gtagCommand } from "../../services/monitoring";

export const inputCheckAndGaTracking = (values) => {
  values.orderId =
    values.orderId &&
    (values.orderId[0] === "#"
      ? values.orderId.substr(1)
      : values.orderId.toUpperCase());

  if (values.orderId && values.orderZip) {
    gtagCommand("Order-Status", "click", "Order Id and Order Zip Look Up");
  } else if (
    !values.orderId &&
    values.orderZip &&
    values.orderEmail.length > 0
  ) {
    gtagCommand("Order-Status", "click", "Order Email Look Up");
  } else if (
    values.orderId &&
    !values.orderZip &&
    values.orderEmail.length > 0
  ) {
    gtagCommand("Order-Status", "click", "Order Id and Order Email Look Up");
  }
};
